// src/utils/debugRouters.js；用于路由信息打印和调试；
import store from '@/store'

export function debugUtils(router) {
    //不是开发环境不输出调试信息
    if (process.env.NODE_ENV !== 'development') return;

    const routes = router.getRoutes();

    // console.log('--- routes = router.getRoutes();  ---')
    // // 确保 routes 是一个数组
    // if (Array.isArray(routes)) {
    //     routes.forEach(route => {
    //         console.log(route);  // 打印每个路由对象
    //     });
    // } else {
    //     console.error("router.getRoutes() did not return an array.");
    // }

    const data = routes.map(r => ({
        name: r.name || '(未命名)',
        path: r.path,
        components: Object.keys(r.components || {}).join(', '),
        children: r.children ? r.children.length : 0
    }));

    console.group('%c[路由调试] 当前注册的 Vue Router 路由信息', 'color: green; font-weight: bold');
    console.table(data);

    //vuex store
    store.dispatch('addDynamicData',{
        key: 'debugRouters',
        value: JSON.stringify(data),
    })

    console.groupEnd();
}

/**
 * 调试信息写入 Vuex（封装 dispatch）
 * @param {string|any} key - 当只传一个参数时视为 value，key 自动为 "info"
 * @param {any} [value] - 可选，如果指定了 key，则这是 value
 */
export function debugInfo(key, value) {

    /*先判断是否是开发环境,是才输出调试信息*/
    const isDev = process.env.NODE_ENV === 'development';
    if (!isDev) return;   //不是开发环境,直接退出;

    let finalKey, finalValue;

    if (arguments.length === 1) {
        finalKey = 'debugInfo';
        finalValue = key;
    } else {
        finalKey = key;
        finalValue = value;
    }


    if (finalValue !== null && typeof finalValue === 'object') {
        finalValue = JSON.stringify(finalValue);
    }

    if (finalKey !== null && typeof finalKey === 'object') {
        finalKey = JSON.stringify(finalKey);
    }


    if (Array.isArray(finalValue) && finalValue.every(item => typeof item === 'object' && item !== null)) {
        // 是对象数组，转换为 JSON 字符串
        finalValue = JSON.stringify(finalValue, null, 2);
        // 可选：应用格式化逻辑（参考之前的 replace 逻辑）
        finalValue = finalValue
            // .replace(/,/g, ',<br>')           // 把英文逗号替换成 <br/>
            .replace(/(?<![:|\[|\{]){/g, '<br>{')
            .replace(/(?<!\[)]/g, '<br>]')
            // .replace(/\[/g, '[<br>')
            .replace(
                /"([^"]+)"\s*:/g,
                '<span style="color: red;">"$1"</span>:')
            .replace(/(\r\n|\n|\r)/g, '<br>') // 把所有换行符替换成 <br/>




    }

    store.dispatch('addDynamicData', {
        key: finalKey,
        value: finalValue
    });
}